/* istanbul ignore file */

export enum ActionTypeText {
    SetField = 'set a field value',
    StyleFieldColor = 'style a field',
    SetMapPinColor = 'style a map pin',
    SendEmail = 'send an email notification',
    Dynamic = '(dynamic)'
}
